export default "__VITE_ASSET__BLgNs7J0__"